import { useTranslation } from 'next-i18next'
import { FC, useEffect, useRef, useState } from 'react'
import PriceCombobox from './PriceCombobox'

type PriceFilterFieldsetProps = {
  min: number | null
  setMin: (value: number | null) => void
  max: number | null
  setMax: (value: number | null) => void
  autofocus?: boolean
}

const priceOptions = [
  100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 900000,
  1000000,
]

const PriceFilterFieldset: FC<PriceFilterFieldsetProps> = ({
  min,
  setMin,
  max,
  setMax,
  autofocus,
}) => {
  const { t } = useTranslation('common')
  const [showMinListbox, setShowMinListbox] = useState<boolean>(false)
  const [showMaxListbox, setShowMaxListbox] = useState<boolean>(false)
  const minInputRef = useRef<HTMLInputElement>(null)
  const maxInputRef = useRef<HTMLInputElement>(null)

  const maxPriceOptions = priceOptions.filter((price) => price > Number(min))

  useEffect(() => {
    if (autofocus) {
      minInputRef?.current?.focus()
    }
  }, [autofocus])

  return (
    <fieldset>
      <legend className="sr-only">Range</legend>

      <div className="mt-6 flex justify-between space-x-14">
        <PriceCombobox
          prices={priceOptions}
          transformPrice={(price) => t('ui.min-price-label', { min: price })}
          listboxId="min-options"
          listboxExpanded={showMinListbox}
          textboxName="priceMin"
          textboxLabel={t('ui.min-price')}
          textboxValue={min}
          textboxPlaceholder={t('ui.min')}
          textboxOnChangeMethod={setMin}
          textboxRef={minInputRef}
          textboxOnFocus={() => {
            setShowMinListbox(true)
            setShowMaxListbox(false)
          }}
          onTextboxSelection={() => {
            maxInputRef?.current?.focus()
          }}
        />

        <span aria-hidden="true" className="mt-8 text-grey-5">
          -
        </span>

        <PriceCombobox
          prices={maxPriceOptions}
          listboxId="max-options"
          listboxExpanded={showMaxListbox}
          textboxRef={maxInputRef}
          textboxName="priceMax"
          textboxLabel={t('ui.max-price')}
          textboxValue={max}
          textboxPlaceholder={t('ui.max')}
          textboxOnChangeMethod={setMax}
          textboxOnFocus={() => {
            setShowMinListbox(false)
            setShowMaxListbox(true)
          }}
        />
      </div>
    </fieldset>
  )
}

export default PriceFilterFieldset
